/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoyaltyTariff { 
    publishByClickCost?: number;
    publishByLeadContactsCost?: number;
    publishFixedCost?: number;
    localPublishFixedCost?: number;
    publishByUserCost?: number;
    publishByUserTargetedCost?: number;
    publishByDiscountCost?: number;
    localPublishByUserCost?: number;
    localPublishByUserTargetedCost?: number;
    includeInNewsletterTier1Cost?: number;
    includeInNewsletterTier2Cost?: number;
    includeInNewsletterTier3Cost?: number;
    searchBoostPerMonthCost?: number;
}

